import { Badge } from "@/components/ui/badge";
import { STOCK_STATUS_LABELS } from "@/types/inventory";

const VARIANTS: Record<string, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  IN_STOCK: "success",
  RESERVED: "warning",
  DISPATCHED: "blue",
  ISSUED: "blue",
  SCRAPPED: "destructive",
  CANCELLED: "outline",
};

export function StockStatusBadge({ status }: { status: string }) {
  return <Badge variant={VARIANTS[status] || "outline"}>{STOCK_STATUS_LABELS[status] || status}</Badge>;
}

/** A small round swatch of a shade's colour, when it has one */
export function Swatch({ hex }: { hex?: string | null }) {
  if (!hex) return null;
  return <span className="inline-block size-3 rounded-full border border-border align-middle mr-1.5" style={{ backgroundColor: hex }} />;
}
